import React, { useState, Fragment } from 'react';
import { Card, CardContent } from '@mui/material';
import Formulario from 'components/formulario';
import { Add } from '@mui/icons-material';
import { functions } from 'constantes/functions';

const Escritos = ({agregarAlListado}) => {

    const handleEdicion = (value) => {
        if (!value) return
        setElements((prevState) => {
            const newElements = {};
            Object.keys(prevState).forEach((key) => {
                newElements[key] = { ...prevState[key] };
            });
            // Persist the radio selection so it survives parent re-renders
            newElements.tipoEdicionEscrito = { ...newElements.tipoEdicionEscrito, value };
            if (value === "5") {
                newElements.tipoEdicion = { ...newElements.tipoEdicion, showInputFormControl: true, pattern: "^([\\w_][\\w_ -.\"\'ÑñwáéíóúÁÉÍÓÚ]*[\\w_.\"\'ÑñwáéíóúÁÉÍÓÚ]){1,65}$", value: newElements.tipoEdicion?.value || "" };
            } else {
                newElements.tipoEdicion = { ...newElements.tipoEdicion, showInputFormControl: false, pattern: "" };
            }
            return newElements;
        });
    }

    const handleWeb = (value) => {
        if (!value) return
        setElements((prevState) => {
            const newElements = {};
            Object.keys(prevState).forEach((key) => {
                newElements[key] = { ...prevState[key] };
            });
            // Persist the radio selection so it survives parent re-renders
            newElements.esWeb = { ...newElements.esWeb, value };
            if (value === "2") {
                newElements.esWebDigitalTitle = { ...newElements.esWebDigitalTitle, showTitleForm: true };
                newElements.linkWeb = { ...newElements.linkWeb, showInputFormControl: true, pattern: "((https?|HTTPS?)|(ftp|FTP))://[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}(/.*)?", value: newElements.linkWeb?.value || "" };
            } else {
                newElements.esWebDigitalTitle = { ...newElements.esWebDigitalTitle, showTitleForm: false };
                newElements.linkWeb = { ...newElements.linkWeb, showInputFormControl: false, pattern: "" };
            }
            return newElements;
        });
    }


    const [elements, setElements] = useState(() => {
        const elementos = {
        tipodeMedioTitle: {
            idelement: "tipodeMedioTitle", title: 'Seleccione el tipo de medio escrito', position: "center", value: "", isError: false, elementType:'titulo', showTitleForm: true,  name: "tipodeMedioTitle",
        },
        tipoMedioEscrito: {
            idelement: "tipoMedioEscrito", value: null, label: "Seleccione *", pattern: "^[1-9][0-9]*$", validators: ['required'],
            errorMessages: ['Seleccione el tipo de medio escrito'], isError: false, elementType: 'autoCompletar', list: [{ id: 1, name: 'Periódico' }, { id: 2, name: 'Revista' }], handler: undefined, autoFocus: true, showSelectAutoComplete: true, width: '100%'
        },
        tipoEscritoTitulo: {
            idelement: "tipoEscritoTitulo", title: 'Elija edicion de medio escrito', position: "center", value: "", isError: false, elementType:'titulo', showTitleForm: true,  name: "tipoEscritoTitulo",
        },
        tipoEdicionEscrito: {
            idelement: "tipoEdicionEscrito", value: "", isError: false, elementType: 'radio', errorMessages: ['Debe seleccionar una opción'],
            options: [{ value: "1", label: 'Diario' }, { value: "2", label: 'Semanal' }, { value: "3", label: 'Quincenal' }, { value: "4", label: 'Mensual' }], handler: handleEdicion,  'disabled': false, isRequired: true, showInputRadio: false, width: '100%'
        },
        tipoEdicion: {
            idelement: "tipoEdicion", value: "", label: "Registre otro tipo de edicion *", pattern: "", validators: ['required'], errorMessages: ['El campo es requerido'], isError: false, elementType:'texto', name:"tipoEdicion", autofocus: false, showInputFormControl: false, width: '100%'
        },
        esWebTitle: {
            idelement: "esWebTitle", title: '¿Tienes sitio Web?', position: "center", value: "", isError: false, elementType:'titulo', showTitleForm: true,  name: "esWebTitle",
        },
        esWeb: {
            idelement: "esWeb", value: null, isError: false, elementType: 'radio', errorMessages: ['Debe seleccionar una opción'],
            options: [{ value: "1", label: 'No' }, { value: "2", label: 'Si' },], handler: handleWeb, 'disabled': false, isRequired: true, showInputRadio: false, width: '100%'
        },
        esWebDigitalTitle: {
            idelement: "esWebDigitalTitle", title: 'Registre el link del medio digital', position: "center", value: "", isError: false, elementType:'titulo', showTitleForm: false,  name: "esWebDigitalTitle",
        },
        linkWeb: {
            idelement: "linkWeb", value: "", label: "Link ejemplo (https://www.tse.org.gt)*", pattern: "", validators: ['required'], errorMessages: ['El campo es requerido'], isError: false, elementType:'texto', name:"linkWeb", autofocus: true, showInputFormControl: false, 'disabled': false, width: '100%'
        },
        };

        Object.keys(elementos).forEach((key) => {
            if (["texto", "areaTexto"].includes(elementos[key]?.elementType)) {
                elementos[key].transformToUppercase = true;
            }
        });

        return elementos;
    });

    const addToTheList = (dataForm) => {
        agregarAlListado(dataForm)
        const elementosReiniciados = functions.reiniciarEstadoDelFormulario({ ...elements })
        setElements({ ...elementosReiniciados })
    };

    const [buttonList] = useState({
        "addToTheList":{"label":"Agregar al listado", "icon": <Add />,"callback":addToTheList,"loading":false,"size":"medium",
        "background":"linear-gradient(45deg, #ffcc00 30%, #d9bd09 90%)", "border":"0px", "borderRadius":"3",
        "boxShadow":"0 3px 5px 2px rgba(168, 142, 50, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false, isCancel: false,
        },
    });

    return (
        <Fragment>
            <Card>
                <CardContent>
                    <Formulario
                        elements={elements}
                        buttonList={buttonList}
                    />
                </CardContent>
            </Card>
        </Fragment>
    );
}

export default Escritos

